module.exports = __webpack_public_path__ + "static/media/link-map-bg.2d9b5ac2.jpg";